import React, { FC } from 'react'
import { IProgramId } from '@ucheba/store/institutions/programs/programId/types'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { List } from '@ucheba/ui/components/List/desktop'
import { LimitedList } from '@ucheba/ui/components/LimitedList/desktop'
import { useSelector } from 'react-redux'
import { authSelectors } from '@ucheba/store/auth'
import { useRouter } from 'next/router'
import { EActivityInfoPart, EActivityTypes } from '@ucheba/utils/types/userActivityTypes'
import { getSingleQuery } from '@ucheba/utils/helpers/router'
import { useUserActivity } from '../../../../../../../utils/hooks/useUserActivity'
import PartnerEmployersItem from '../../../../../uz/components/PartnerEmployersItem/desktop'
import { useGetInstitutionsId } from '../bll/useGetInstitutionsId'

const ProgramIdPageEmployers: FC<{
  institutionPartnerCompanies: IProgramId['institutionPartnerCompanies']
}> = (props) => {
  const { institutionPartnerCompanies } = props
  const isAuth = useSelector(authSelectors.isAuth)
  const { query } = useRouter()
  const programId = query?.id

  const { setUserActivity } = useUserActivity()

  const institutionId = useGetInstitutionsId()

  const handleShowAllClick = async (): Promise<void> => {
    await setUserActivity({
      activityType: EActivityTypes.infoPartViewed,
      institutionId,
      data: { infoPart: EActivityInfoPart.employers },
      programId: getSingleQuery(programId) as undefined | number,
    })
  }

  if (!institutionPartnerCompanies || institutionPartnerCompanies.length === 0)
    return null

  return (
    <>
      <Heading h3='Работодатели-партнеры' spacing='large' />

      <LimitedList
        id='employers'
        items={institutionPartnerCompanies}
        isAuth={isAuth}
        buttonText='Показать всех работодателей'
        limit={3}
        showMore
        onShowAll={handleShowAllClick}
        buttonSpacing={null}
      >
        {({ limitedItems }) => (
          <List>
            {limitedItems.map((item) => {
              const { id, name, externalLink, logo, description } = item.company

              return (
                <PartnerEmployersItem
                  name={name}
                  description={description}
                  externalLink={externalLink}
                  logo={logo}
                  key={id}
                  isDivider
                />
              )
            })}
          </List>
        )}
      </LimitedList>
    </>
  )
}

export default ProgramIdPageEmployers
